import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Button } from './ui/button';
import { Cookie, X } from 'lucide-react';

const CookieBanner = () => {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    // Check if user has already made a choice
    const consent = localStorage.getItem('cookie_consent');
    if (!consent) {
      // Show banner after a short delay
      const timer = setTimeout(() => setShowBanner(true), 1000);
      return () => clearTimeout(timer);
    }
  }, []);

  const acceptAll = () => {
    localStorage.setItem('cookie_consent', JSON.stringify({
      necessary: true,
      analytics: true,
      timestamp: new Date().toISOString()
    }));
    setShowBanner(false);
  };

  const acceptNecessary = () => {
    localStorage.setItem('cookie_consent', JSON.stringify({
      necessary: true,
      analytics: false,
      timestamp: new Date().toISOString()
    }));
    setShowBanner(false);
  };

  if (!showBanner) return null;

  return (
    <div 
      style={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 40,
        backgroundColor: '#ffffff',
        borderTop: '1px solid #e2e8f0',
        boxShadow: '0 -4px 20px rgba(0, 0, 0, 0.1)'
      }}
      className="p-4 sm:p-6"
    >
      <div className="max-w-6xl mx-auto">
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          
          {/* Text */}
          <div className="flex items-start space-x-3 flex-1">
            <div style={{backgroundColor: '#dbeafe'}} className="p-2 rounded-lg flex-shrink-0">
              <Cookie style={{color: '#2563eb'}} className="h-5 w-5" />
            </div>
            <div>
              <p style={{color: '#1e293b'}} className="font-medium mb-1">
                Ce site utilise des cookies
              </p>
              <p style={{color: '#64748b'}} className="text-sm">
                Nous utilisons des cookies essentiels pour le fonctionnement du site et des cookies 
                optionnels pour améliorer votre expérience.{' '}
                <Link to="/cookies" style={{color: '#2563eb'}} className="hover:underline">
                  En savoir plus
                </Link>
              </p>
            </div>
          </div>

          {/* Buttons */}
          <div className="flex items-center space-x-3 flex-shrink-0">
            <Button 
              variant="outline" 
              onClick={acceptNecessary}
              style={{color: '#475569', borderColor: '#e2e8f0'}}
              className="text-sm"
            >
              Essentiels uniquement
            </Button>
            <Button 
              onClick={acceptAll}
              className="bg-emerald-600 hover:bg-emerald-700 text-sm"
            >
              Tout accepter
            </Button>
            <button 
              onClick={acceptNecessary}
              style={{color: '#94a3b8'}}
              className="p-1 hover:bg-slate-100 rounded-lg sm:hidden"
            >
              <X className="h-5 w-5" />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;
